// src/components/search/SearchResultItem.tsx
import React from 'react';
import { Users, FileText, Shield } from 'lucide-react';
import { CommandItem } from '../ui/command';
import { cn } from '@/lib/utils';

interface Props {
  item: {
    id: string;
    name: string;
    image?: string;
    logo?: string;xx
    jobTitle?: string;
    company?: string;
    city?: string;
    sports?: string[];
    connectionCount?: number;
  };
  type: 'player' | 'trainer' | 'post' | 'club';
  onSelect: (type: string, id: string) => void;
}

const SearchResultItem: React.FC<Props> = ({ item, type, onSelect }) => (
  <CommandItem onSelect={() => onSelect(type, item.id)}>
    <div className="flex items-center space-x-3">
      {(type === 'player' || type === 'trainer') ? (
        <img
          src={item.image || '/default-avatar.png'}
          alt={item.name}
          className="w-8 h-8 rounded-full object-cover border border-dark-400"
        />
      ) : type === 'club' ? (
        item.logo ? (
          <img
            src={item.logo}
            alt={item.name}
            className="w-8 h-8 rounded-full object-cover border border-dark-400"
            onError={e => {
              const img = e.currentTarget;
              const parent = img.parentNode as HTMLElement;
              if (parent) {
                parent.innerHTML = `<div class="w-8 h-8 rounded-full flex items-center justify-center bg-dark-300 border border-dark-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gold-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>`;
              }
            }}
          />
        ) : (
          <div className="w-8 h-8 rounded-full flex items-center justify-center bg-dark-300 border border-dark-400">
            <Shield className="h-4 w-4 text-gold-400" />
          </div>
        )
      ) : (
        <FileText className="h-4 w-4 text-gold-400" />
      )}
      <div>
        <p className="text-white font-medium">{item.name}</p>
        {(type === 'player' || type === 'trainer') && (
          <p className="text-sm text-gray-400">
            {item.jobTitle ? `${item.jobTitle} @ ${item.company}` : 'No Job Info'}
          </p>
        )}
        {type === 'club' && (
          <p className="text-sm text-gray-400">
            {item.city}
            {item.sports?.length ? ` • ${item.sports.join(', ')}` : ''}
          </p>
        )}
      </div>
    </div>
  </CommandItem>
);

export default SearchResultItem;
